// // const japaneseRegex = /^[ぁ-んァ-ン一-龥]+$/;
import { z } from "zod/v4";
// logic-helpersのkana.tsあたりに入れられそう
const HiraganaSchema = z.string().regex(/^[ぁ-ん]+$/, {
    message: "ひらがなで入力してください。",
});
export const Hiragana = {
    schema: HiraganaSchema,
};
//# sourceMappingURL=hiragana.js.map